import * as React from "react";
import {
  Icon,
  Popover,
  PopoverInteractionKind,
  PopoverPosition,
  UL,
} from "@blueprintjs/core";
import { css } from "@emotion/core";

export default function FolderInfos() {
  return (
    <Popover
      interactionKind={PopoverInteractionKind.HOVER}
      position={PopoverPosition.RIGHT}
      content={
        <UL
          css={css`
            max-width: 400px;
            margin: 0;
            padding-right: 1rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
          `}
        >
          <li>Surveys must belong to a folder.</li>
          <li>
            Folders are used for survey organization and for access control to
            the surveys within them. A users’ membership to a folder determines
            the priviledges they have with the surveys within that folder.
            Membership types are : admin, member, read-only and external.
            Permissions propagate downward and are inherited by all child
            surveys and folders.
          </li>
          <li>Child folders inherit the permissions of the parent folder.</li>
        </UL>
      }
    >
      <Icon
        css={css`
          margin-left: 1rem;
        `}
        icon="help"
      />
    </Popover>
  );
}
